<div class="sales-history-control">
  <div class="search-box">
    <select [formControl]="searchType">
      <option value="1">BUSCA POR CNPJ</option>
      <option value="2">BUSCA POR RAZÃO SOCIAL</option>
    </select>
    <input
      #inputValue
      *ngIf="searchType.value == 1"
      [(ngModel)]="filterText"
      placeholder="01.234.567/0001-00"
      [textMask]="{
        mask: fiscalNumberMask,
        guide: false,
        keepCharPositions: true
      }"
      (keypress)="onPressEnterSearchCompanies($event)"
    />
    <input #inputValue *ngIf="searchType.value == 2" [(ngModel)]="filterText" placeholder="Razão Social" (keypress)="onPressEnterSearchCompanies($event)" />
    <div class="search-icon-container" (click)="onSearchCompany(filterText)">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>

  <select class="filter" id="filter" (change)="onSearchCompany(filterText)">
    <option value="LastDay">{{ filterBy.LastDay }}</option>
    <option value="Last7Days" selected="selected">
      {{ filterBy.Last7Days }}
    </option>
    <option value="Last15Days">{{ filterBy.Last15Days }}</option>
    <option value="LastMonth">{{ filterBy.LastMonth }}</option>
  </select>
</div>
<div class="content-container">
  <p *ngIf="salesHistoryList().length === 0" style="color: #000">
    {{ messageResult.getMessage() }}
  </p>
  <div class="sales-card-grid">
    <sales-history-company-card
      *ngFor="let salesHistory of salesHistoryList()"
      [salesHistoryCompanySummary]="salesHistory"
      (detailSalesHistory)="detailSalesHistory($event)"
    ></sales-history-company-card>
  </div>
  <div fxLayoutAlign="end end">
    <a class="more-cards-btn" (click)="searchMoreSalesHistories()" *ngIf="showLoadMore">
      <span class="btn-title">carregar mais empresas</span>
    </a>
  </div>
</div>
